function TableView2({ calculationResult }) {
  // Helper function to format values - show N/A for negative values
  const formatValue = (value) => {
    if (value < 0) {
      return "N/A";
    }
    return value;
  };

  return (
    <div className="results-section">
      <table className="table-view">
        <thead>
          <tr>
            <th className="table-head-font width-75p">Option 1</th>
            <th className="table-head-font width-25p">Per Acre in Cr</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>OUTRIGHT PRICE WITH IMMEDIATE PAYMENT</td>
            <td rowspan="2" className="merged-cell text-ali-cen">
              {formatValue(calculationResult.D10_value)}
            </td>
          </tr>
          <tr>
            <td>ON THE DATE OF ADVANCE, PROPERTY TO BE READY FOR SUBMISSION</td>
          </tr>
        </tbody>
      </table>

      <div style={{ marginTop: "10px" }}></div>

      <table className="table-view">
        <thead>
          <tr>
            <th className="table-head-font width-75p">
              OPTION 2 - ORD - REGUALR 15% - 85%
            </th>
            <th className="table-head-font width-25p">Per Acre in Cr</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>ORD - REGULAR</td>
            <td rowspan="4" className="merged-cell text-ali-cen">
              {formatValue(calculationResult.D14_value)}
            </td>
          </tr>
          <tr>
            <td>15% ON AGREEMENT AND BALANCE 85% 12 MONTH</td>
          </tr>
          <tr>
            <td>
              APPROVAL POWER TO BE PROVIDED INCL REGN OF OSR AND AGREEMENT OF
              SALE
            </td>
          </tr>
          <tr>
            <td>ON THE DATE OF ADVANCE, PROPERTY TO BE READY FOR SUBMISSION</td>
          </tr>
        </tbody>
      </table>

      <div style={{ marginTop: "10px" }}></div>

      <table className="table-view">
        <thead>
          <tr>
            <th className="table-head-font width-75p">
              OPTION 3 - ORD - REGUALR 10% - 90%
            </th>
            <th className="table-head-font width-25p">Per Acre in Cr</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>ORD - REGULAR - 12 MONTHS</td>
            <td rowspan="4" className="merged-cell text-ali-cen">
              {formatValue(calculationResult.D20_value)}
            </td>
          </tr>
          <tr>
            <td>10% ON AGREEMENT AND BALANCE 90% ON 12TH MONTH</td>
          </tr>
          <tr>
            <td>
              APPROVAL POWER TO BE PROVIDED INCL REGN OF OSR AND AGREEMENT OF
              SALE
            </td>
          </tr>
          <tr>
            <td>ON THE DATE OF ADVANCE, PROPERTY TO BE READY FOR SUBMISSION</td>
          </tr>
        </tbody>
      </table>

      <table className="table-view">
        <thead>
          <tr>
            <th className="table-head-font width-75p">
              OPTION 4 - ORD - REGUALR 5% - 95%
            </th>
            <th className="table-head-font width-25p">Per Acre in Cr</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>ORD - REGULAR</td>
            <td rowspan="4" className="merged-cell text-ali-cen">
              {formatValue(calculationResult.D26_value)}
            </td>
          </tr>
          <tr>
            <td>5% ON AGREEMENT AND BALANCE 95% ON 12TH MONTH</td>
          </tr>
          <tr>
            <td>
              APPROVAL POWER TO BE PROVIDED INCL REGN OF OSR AND AGREEMENT OF
              SALE
            </td>
          </tr>
          <tr>
            <td>ON THE DATE OF ADVANCE, PROPERTY TO BE READY FOR SUBMISSION</td>
          </tr>
        </tbody>
      </table>

      <div className="card-header dis-none">
        <img
          className="img-logo"
          src="/Casagrand-Logo1.webp"
          alt="logo"
          width={200}
        />
        <h2 className="padding-10">Land Info and Calculation</h2>
      </div>

      <table className="table-view">
        <thead>
          <tr>
            <th className="table-head-font width-75p">
              OPTION 5 - ORD - 24 10% - 10% - 80%
            </th>
            <th className="table-head-font width-25p">Per Acre in Cr</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>ORD - 24</td>
            <td rowspan="4" className="merged-cell text-ali-cen">
              {formatValue(calculationResult.D32_value)}
            </td>
          </tr>
          <tr>
            <td>
              10% ON AGREEMENT AND 10% ON APPROVAL (IN 12 MONTHS) AND BALANCE
              80% ON 24TH MONTH
            </td>
          </tr>
          <tr>
            <td>
              APPROVAL POWER TO BE PROVIDED INCL REGN OF OSR AND AGREEMENT OF
              SALE
            </td>
          </tr>
          <tr>
            <td>ON THE DATE OF ADVANCE, PROPERTY TO BE READY FOR SUBMISSION</td>
          </tr>
        </tbody>
      </table>

      <table className="table-view">
        <thead>
          <tr>
            <th className="table-head-font width-75p">
              OPTION 6 - ORD - 24 10% - 10% - 20% 20% 20% 20%
            </th>
            <th className="table-head-font width-25p">Per Acre in Cr</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>ORD - 24</td>
            <td rowspan="4" className="merged-cell text-ali-cen">
              {formatValue(calculationResult.D39_value)}
            </td>
          </tr>
          <tr>
            <td>
              10% ON AGREEMENT AND 10% ON APPROVAL (IN 12 MONTHS) AND 20% EVERY
              QUARTER FROM 15TH MONTH
            </td>
          </tr>
          <tr>
            <td>
              APPROVAL POWER TO BE PROVIDED INCL REGN OF OSR AND AGREEMENT OF
              SALE
            </td>
          </tr>
          <tr>
            <td>ON THE DATE OF ADVANCE, PROPERTY TO BE READY FOR SUBMISSION</td>
          </tr>
        </tbody>
      </table>

      <table className="table-view">
        <thead>
          <tr>
            <th className="table-head-font width-75p">OPTION 7 - JV</th>
            <th className="table-head-font width-25p">Per Acre in Cr</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>JV CG RATIO</td>
            <td className="text-ali-cen">{formatValue(calculationResult.D47_value)}%</td>
          </tr>

          <tr>
            <td>JV LO RATIO</td>
            <td className="text-ali-cen">{formatValue(calculationResult.D48_value)}%</td>
          </tr>

          <tr>
            <td>10% OF PROPERTY VALUE AS ADVANCE</td>
            <td className="text-ali-cen">{formatValue(calculationResult.D49_value)}</td>
          </tr>

          <tr>
            <td>
              APPROVAL POWER TO BE PROVIDED INCL REGN OF OSR AND AGREEMENT OF
              SALE
            </td>
            <td rowspan="4" className="merged-cell text-ali-cen">
              {formatValue(calculationResult.D50_value)}
            </td>
          </tr>
          <tr>
            <td>ON THE DATE OF ADVANCE, PROPERTY TO BE READY FOR SUBMISSION</td>
          </tr>
          <tr>
            <td>
              NO COMMITMENT ON APPROVAL TIMELINE. THIS IS CALENDAR COMMITMENT
            </td>
          </tr>
          <tr>
            <td>SHARING : NOT SHARING: FRC</td>
          </tr>
        </tbody>
      </table>

      <table className="table-view">
        <thead>
          <tr>
            <th className="table-head-font width-75p">
              OPTION 8 - DEVELOPMENT MODEL
            </th>
            <th className="table-head-font width-25p"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              LO TO INFUSE CAPITAL FOR APPROVALS & ANY INITIAL FUND GAP FOR
              CONSTRUCTION
            </td>
            <td rowspan="4" className="merged-cell text-ali-cen">
              14% OF THE TOPLINE GIVEN TO CG
            </td>
          </tr>
          <tr>
            <td>CG ONLY CHARGES 14% OF THE TOTAL REVENUE</td>
          </tr>
          <tr>
            <td>
              ALL OTHER STAFF COST WHO ARE ATTRIBUTABLE TO PROJECTS (SALES,
              MKTG, ENGG ETC) WILL BE DEDICATEDLY BUILT TO PROJECT AS PART OF
              OPERATIVE COST
            </td>
          </tr>
          <tr>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default TableView2;
